module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mceltis11-16bd9e97bcae8ec36d4270bbec78ed17.jpg";